export function formatCurrency(value?: string | number): string {
  if (value === undefined || value === null) return "R$ 0,00";

  let numberValue: number;

  if (typeof value === "string") {
    const cleaned = value
      .replace(/[^\d,.-]/g, "")
      .replace(/\./g, "")
      .replace(",", ".");

    numberValue = parseFloat(cleaned);

    if (isNaN(numberValue)) return "R$ 0,00";
  } else {
    numberValue = value;
  }

  return numberValue.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
